import { z } from 'zod';

import { MESSAGE_DATA_TYPES } from './discriminators';

/**
 * Answer message data — set by the backend when an expert sends a substantive
 * reply to an inquiry. Used to trigger automatic reference search suggestions.
 */
export const payloadSchema = z.object({
  type: z.literal(MESSAGE_DATA_TYPES.ANSWER),
});

export type AnswerMessageData = z.infer<typeof payloadSchema>;

/** Carries no fields of its own — the `type` discriminator is the whole payload. */
export const attributesSchema = z.object({});
